import apiRequest from "../../../apiRequest";
import { endPoints } from "../../../apis";

// export const fetchBusinessById = async (id) => {
//     // console.log(id)
//     return apiRequest.get(`${endPoints.GET_SINGLE_BUSINESS}/${id}`);
// };

export const fetchPartnerById = async (id) => {
    // console.log(id)
    return apiRequest.get(`${endPoints.GET_SINGLE_PARTNER}/${id}`);
};
export const fetchPartners = async () => {
    return apiRequest.get(endPoints.GET_PARTNER);
};
export const fetchLivePartners = async () => {
    return apiRequest.get(endPoints.GET_LIVE_PARTNERS);
};
// wallet
export const fetchPartnerWalletTypes = async () => {
    return apiRequest.get(endPoints.GET_PARTNER_WALLET_TYPES);
}
export const fetchPartnerWallet = async (id) => {
    // console.log(id)
    return apiRequest.get(`${endPoints.GET_PARTNER_WALLET}/${id}`);
};
export const createOrUpdateWallet = async (data) => {
    return apiRequest.post(endPoints.CREATE_OR_UPDATE_WALLET_TRANSACTIONS, data);
}
export const fetchPartnerWalletTransactions = async (id, params) => {
    // console.log(id, params)
    return apiRequest.get(`${endPoints.GET_PARTNER_WALLET_TRANSACTIONS}/${id}`, params);
}
export const fetchDriverOrders = async (id, params) => {
    // console.log(id, params)
    return apiRequest.get(`${endPoints.GET_DRIVERS_ORDERS}/${id}`, params);
};

export const fetchPartnerVehicles = async (id, params) => {
    return apiRequest.get(`${endPoints.GET_PARTNER_VEHICLE}/${id}`, params);
}

export const updatePartnerPayoutStatus = async ({ id, status }) => {
    return apiRequest.put(`${endPoints.UPDATE_DRIVER_PAYOUT_STATUS}/${id}`, { status });
}

export const getPartnerStatus = async () => {
    return apiRequest.get(endPoints.GET_DRIVER_PAYOUT_STATUSES);
}

// DRIVER SETTLEMENT
export const fetchPartnersSettlement = async ({ status = "All" }) => {
    const params = { status };
    return apiRequest.get(endPoints.GET_DRIVER_SETTLEMENT, params);
};

export const updatePartnerStatus = async ({ id, status, token }) => {
    const config = token
        ? {
            headers: {
                "x-access-token": token,
            },
        }
        : {};

    return apiRequest.put(`${endPoints.STATUS_CATEGORY}/${id}`, { status }, config);
};


export const deletePartner = async ({ id, token }) => {
    const config = token
        ? {
            headers: {
                "x-access-token": token,
            },
        }
        : {};

    return apiRequest.delete(`${endPoints.DELETE_CATEGORY}/${id}`, config);
};

export const fetchPartnerOrders = async ({ id, page = 1, total = 0 }) => {
    const params = { page, total };
    return apiRequest.get(`${endPoints.GET_DRIVERS_ORDERS}/${id}`, params);
};



export const fetchCoa = async () => {
    return apiRequest.get(`${endPoints.GET_COA}`);
};

export const createOrAddAmount = async (data) => {
    return apiRequest.post(`${endPoints.CREATE_OR_ADD_AMOUNT}`, data);
};

export const getWalletByUserId = async (id) => {
    return apiRequest.get(`${endPoints.GET_WALLET_BY_USER_ID}/${id}`);
};


export const getTransactionsByWalletId = async ({ walletId, page = 1, total = 100 }) => {
    const params = { page, total };
    return apiRequest.get(`${endPoints.GET_TRANSACTIONS_BY_WALLET_ID}/${walletId}`, params);
};
